// Core
import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

//redux
import { useDispatch } from "react-redux";
import { fetchContactList, fetchDistributorList } from "../../../Redux/Slices/chooseKgSlice";

//Import Scss
import "./styles.scss";

//Import assets
import assets from "../../../Assets"

//Import Custom Components
import NormalTable from "Components/Common/Table";
import Pagination from "Components/Pagination";
import DatePicker from "../../Common/DatePicker";
import "react-datepicker/dist/react-datepicker.css";

const ContactUs = () => {
    const headerDetails = [
        { label: "S No", sortKey: false },

        {
            label: "Name",
            sortKey: true,
            singleClickFunc: () => {
                setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "firstName" });
            },
        },
        {
            label: "Company Name",
            sortKey: true,
            singleClickFunc: () => {
                setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "companyName" });
            },
        },
        // {
        //     label: "Company Address",
        //     sortKey: true,
        //     singleClickFunc: () => {
        //         setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "companyAddress" });
        //     },
        // },
        // {
        //     label: "Company Website",
        //     sortKey: true,
        //     singleClickFunc: () => {
        //         setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "companyWebsite" });
        //     },
        // },
        // {
        //     label: "Phone Number",
        //     sortKey: true,
        //     singleClickFunc: () => {
        //         setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "phoneNumber" });
        //     },
        // },
        {
            label: "Email",
            sortKey: true,
            singleClickFunc: () => {
                setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "email" });
            },
        },
        {
            label: "Message",
            sortKey: true,
            singleClickFunc: () => {
                setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "message" });
            },
        },
        {
            label: "Submitted On",
            sortKey: true,
            singleClickFunc: () => {
                setSortOptions({ sort_by: !sortOptions.sort_by, order_by: "createdAt" });
            },
        },
    ];

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [contactList, setContactList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [sortOptions, setSortOptions] = useState({ sort_by: false, order_by: "createdAt" });
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [search, setSearch] = useState("");

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    const handleFromDate = (date) => {
        // if (date) {
        //   setFromDate(new Date(date));
        // } else {
        //   setFromDate(null); 
        // }
        setFromDate(date ? new Date(date) : null)
        if (toDate && date && toDate < date) {
            setToDate(null);
        }
    };
    const handleToDate = (date) => {
        setToDate(date ? new Date(date) : null);
    };
    const formatDate = (dateString) => {
        const date = new Date(dateString);

        // Extract day, month, and year
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();

        // Extract hours and minutes
        // let hours = date.getHours();
        // const minutes = String(date.getMinutes()).padStart(2, '0');

        // Determine AM/PM and format hours
        // const ampm = hours >= 12 ? 'PM' : 'AM';
        // hours = hours % 12 || 12;

        // Format the date and time
        return `${day}/${month}/${year}`;
    }

    function formatSendDate(dateString) {
        if (dateString === "") {
            return ""
        }
        const date = new Date(dateString);

        // Extract year, month, and day
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, '0');

        // Format the date as YYYY-MM-DD
        const formattedDate = `${year}-${month}-${day}`;

        // Prevent sending "1970-01-01"
        return formattedDate === "1970-01-01" ? null : formattedDate;
    }



    const getInitials = (name) => {
        const [firstName = "", lastName = ""] = name.split(" ");
        return (firstName[0] || "").toUpperCase() + (lastName[0] || "").toUpperCase();
    };

    useEffect(() => {
        setIsLoading(true)
        dispatch(
            fetchContactList({
                data: {
                    page: currentPage,
                    limit: "10",
                    search: search,
                    sort_by: sortOptions.sort_by ? "ASC" : "DESC",
                    order_by: sortOptions.order_by,
                    fromDate: formatSendDate(fromDate) || "",
                    ...(formatSendDate(toDate) && { toDate: formatSendDate(toDate) }),
                },
                callBack: (value) => {
                    console.log(value)
                    setContactList(value?.data?.data_list || [])
                    setTotalPages(value?.data?.pageMeta?.totalPages || 1)
                    setTotalCount(value?.data?.pageMeta?.total || 0);
                    setIsLoading(false)
                },
            })
        );
    }, [sortOptions, currentPage, fromDate, toDate, search])

    return (
        <div className="contactContainer">
            <div className="contactHeader">
                <p></p>
                <div className="contactDatePicker">
                    <p className="totalCount">
                        Total count : {totalCount}
                    </p>
                    <input
                        type="text"
                        placeholder="Search by name, email, or company"
                        value={search}
                        onChange={(e) => {
                            setSearch(e.target.value);
                            setCurrentPage(1);
                        }}
                        className="searchInput"
                    />

                    <DatePicker
                        placeholderText="From Date"
                        selected={fromDate}
                        onChange={handleFromDate}
                        format={"dd-MM-yyyy"}
                        width='14vw'
                        height='6.5vh'
                    />
                    <DatePicker
                        placeholderText="To Date"
                        selected={toDate}
                        minDate={fromDate}
                        onChange={handleToDate}
                        format={"dd-MM-yyyy"}
                        width='14vw'
                        height='6.5vh'
                    />
                </div>
            </div>
            <div className="contactTableContainer">
                <NormalTable
                    headerDetails={headerDetails}
                // pagination={true}
                >{contactList.length > 0
                    ? contactList.map((list, index) => {
                        const fullName = `${list.firstName || ""} ${list.lastName || ""}`.trim();

                        return (
                            <tr className="border" key={list.id}>
                                <td
                                    style={{
                                        paddingLeft: "18px",
                                    }}
                                >
                                    {(currentPage - 1) * 10 + (index + 1)}
                                </td>
                                <td>
                                    <div
                                        style={{
                                            display: "flex",
                                            gap: "3px",
                                            alignItems: "center",
                                        }}
                                    >
                                        {

                                            fullName ? (
                                                <div
                                                    style={{
                                                        height: "30px",
                                                        width: "30px",
                                                        backgroundColor: "#1E2156",
                                                        borderRadius: "50%",
                                                        color: "white",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    {getInitials(fullName)}
                                                </div>
                                            ) : ""}

                                        <p>{fullName || "-"}</p>

                                    </div>
                                </td>

                                <td>{list?.companyName || "-"}</td>
                                {/* <td>{list?.companyAddress || "-"}</td>
                                <td>{list?.companyWebsite || "-"}</td>
                                <td>{list?.phoneNumber || "-"}</td> */}
                                <td>{list?.email || "-"}</td>
                                {/* <td>
  <span className={`status ${list?.status?.toLowerCase()}`}>
    {list?.status || "-"}
  </span>
</td> */}

                                {/* <td> {list?.product_name?.length > 30
                          ? `${list?.product_name.slice(0, 30)}...`
                          : list?.product_name}</td>
                  <td>{list?.quantity || "-"}</td> */}
                                <td style={{ maxWidth: "250px" }}>{list?.message || "-"}</td>
                                <td>{formatDate(list?.createdAt) || "-"}</td>
                            </tr>
                        );
                    })
                    : " "}
                </NormalTable>
                {contactList.length > 0 ? '' : <p style={{ textAlign: 'center', fontFamily: 'poppins', fontSize: "4vh" }}>{isLoading ? "Loading" : "No Data Found"} </p>}
                {contactList.length > 0 ?
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                    /> : " "
                }
            </div>
        </div>
    );
};

export default ContactUs;